/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";

import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

import TrainingRequest from "components/trainingRequests/TrainingRequest";

class TrainingRequests extends Component {
  state = {
    filteredTrainingRequestsData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    dataFetched: false,
    sort_by: "trEmployee",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.setState({ filteredTrainingRequestsData: this.props.data });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({ filteredTrainingRequestsData: this.props.data });
    }

    if (this.state.filterTerm !== prevState.filterTerm) {

      this.setState({
        filteredTrainingRequestsData: this.props.data.filter((item) => {
          return (
            Helpers
              .getTurkishCharaterFixedList(item.employee.name)
              .includes(
                Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
              ) ||
            Helpers
              .getTurkishCharaterFixedList(item.requestedBy.name)
              .includes(
                Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
              ) ||
            Helpers
              .getTurkishCharaterFixedList(item.training.name)
              .includes(
                Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
              )
          );
        }),
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredTrainingRequestsData?.length > 0
              ? this.state.filteredTrainingRequestsData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {/* <button className="export-button" onClick={this.handleExportCSV}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button> */}
      </div>
    );
  };

  trTrainingMethod = "";
  trTraining = "";
  trLocation = "";
  trRequestedBy = "";
  trEmployee = "";
  trAvailableQuota = "";
  trDuration = "";
  trStatus = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trTrainingMethod = "";
    this.trTraining = "";
    this.trLocation = "";
    this.trRequestedBy = "";
    this.trEmployee = "";
    this.trAvailableQuota = "";
    this.trDuration = "";
    this.trStatus = "";

    switch (this.state.sort_by) {
      case "trTrainingMethod":
        this.trTrainingMethod = `_${this.state.sort_dir}`;
        break;

      case "trTraining":
        this.trTraining = `_${this.state.sort_dir}`;
        break;

      case "trLocation":
        this.trLocation = `_${this.state.sort_dir}`;
        break;

      case "trRequestedBy":
        this.trRequestedBy = `_${this.state.sort_dir}`;
        break;

      case "trEmployee":
        this.trEmployee = `_${this.state.sort_dir}`;
        break;

      case "trAvailableQuota":
        this.trAvailableQuota = `_${this.state.sort_dir}`;
        break;

      case "trDuration":
        this.trDuration = `_${this.state.sort_dir}`;
        break;

      case "trStatus":
        this.trStatus = `_${this.state.sort_dir}`;
        break;

      default:
        this.trEmployee = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredTrainingRequestsData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trTrainingMethod":
          return this.state.sort_dir === "desc"
            ? a.trainingMethod?.label.localeCompare(b.trainingMethod?.label)
            : b.trainingMethod?.label.localeCompare(a.trainingMethod?.label);
        case "trTraining":
          return this.state.sort_dir === "desc"
            ? a.training?.name.localeCompare(b.training?.name)
            : b.training?.name.localeCompare(a.training?.name);
        case "trLocation":
          return this.state.sort_dir === "desc"
            ? (a.trainingLocation ?? "").localeCompare((b.trainingLocation ?? ""))
            : (b.trainingLocation ?? "").localeCompare((a.trainingLocation ?? ""));
        case "trRequestedBy":
          return this.state.sort_dir === "desc"
            ? a.requestedBy?.name.localeCompare(b.requestedBy?.name)
            : b.requestedBy?.name.localeCompare(a.requestedBy?.name);
        case "trEmployee":
          return this.state.sort_dir === "desc"
            ? a.employee?.name.localeCompare(b.employee?.name)
            : b.employee?.name.localeCompare(a.employee?.name);
        case "trAvailableQuota":
          return this.state.sort_dir === "desc"
            ? a.availableQuota - b.availableQuota
            : b.availableQuota - a.availableQuota;
        case "trDuration":
          return this.state.sort_dir === "desc"
            ? a.duration - b.duration
            : b.duration - a.duration;
        case "trStatus":
          return this.state.sort_dir === "desc"
            ? a.status.value - b.status.value
            : b.status.value - a.status.value;
        default:
          return this.state.sort_dir === "desc"
            ? a.employee?.name.localeCompare(b.employee?.name)
            : b.employee?.name.localeCompare(a.employee?.name);
      }
    });

    return sorted.slice(start, end).map((request) => {
      return <TrainingRequest key={request.key} request={request} />;
    });
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="trainingRequests"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trTrainingMethod")}
                  className={`all sorting${this.trTrainingMethod}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Tür">10601</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trTraining")}
                  className={`all sorting${this.trTraining}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Eğitim Adı">10602</Trans>
                  </div>
                </th>

                <DesktopBreakpoint>
                  <th className="none">
                    <div className="tableTitle">
                      <Trans desc="Tarih">10603</Trans>
                    </div>
                  </th>

                  <th
                    onClick={() => this.reOrder("trLocation")}
                    className={`all sorting${this.trLocation}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Eğitim Yeri">10604</Trans>
                    </div>
                  </th>

                  <th
                    onClick={() => this.reOrder("trRequestedBy")}
                    className={`all sorting${this.trRequestedBy}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Talep Eden">10605</Trans>
                    </div>
                  </th>

                  <th
                    onClick={() => this.reOrder("trEmployee")}
                    className={`all sorting${this.trEmployee}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Çalışan">10606</Trans>
                    </div>
                  </th>

                  <th
                    onClick={() => this.reOrder("trAvailableQuota")}
                    className={`all sorting${this.trAvailableQuota}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Kontenjan">10607</Trans>
                    </div>
                  </th>

                  <th
                    onClick={() => this.reOrder("trDuration")}
                    className={`all sorting${this.trDuration}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Süre">10608</Trans>
                    </div>
                  </th>

                  <th
                    onClick={() => this.reOrder("trStatus")}
                    className={`all sorting${this.trStatus}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Talep Durumu">10609</Trans>
                    </div>
                  </th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ application }) => {
  return {
    application,
  };
};

export default connect(
  mapStateToProps,
  {}
)(containsLongRunningProcess(requireAuth(TrainingRequests)));
